import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export interface UserPermissionsResponse {
  permissions: string[];
}

export const rbacApi = createApi({
  reducerPath: 'rbacApi',
  baseQuery: createAuthBaseQuery(),
  endpoints: (builder) => ({
    getUserPermissions: builder.query<UserPermissionsResponse, void>({
      query: () => 'permissions/user',
    }),
    getAllPermissions: builder.query<Record<string, string[]>, void>({
      query: () => 'permissions/all',
    }),
  }),
});

export const { useGetUserPermissionsQuery, useGetAllPermissionsQuery } = rbacApi;
